import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../components/Button/Button';
import { MeterIdentificationFooter as messages } from '../messages';

export const MeterIdentificationFooter: VFC = () => (
  <Button key="submit" block form="meterIdentificationForm" htmlType="submit" type="primary">
    <FormattedMessage {...messages.confirm} />
  </Button>
);
